import _ from 'lodash';
import {FETCH_CATEGORIES, CLEAN_CATEGORIES, DELETE_CATEGORY, DELETE_CATEGORIES} from './types';
import { request, __ } from '../functions';

export const fetchCategories = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/categories', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_CATEGORIES, payload: data });
    });
};

export const deleteCategory = (screen, id) => {
    return dispatch => request(`/categories/delete/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            // Produkt sa nepodarilo zmazat
            screen.showSnackbar('error', __('Nepodarilo sa zmazať kategóriu'));
            return;
        }

        screen.showSnackbar('success', __('Kategória bola zmazaná'));

        dispatch({ type: DELETE_CATEGORY });
    });
};

export const deleteCategories = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/categories/multiDelete/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            // Produkty sa nepodarilo zmazat
            screen.showSnackbar('error', __('Nepodarilo sa zmazať kategórie'));
            return;
        }

        screen.showSnackbar('success', __('Kategórie boli zmazané'));

        dispatch({ type: DELETE_CATEGORIES });
    });
};

export const cleanCategories = () => ({ type: CLEAN_CATEGORIES });
